import React from "react";
import { Download, FileText, File, FileType } from "lucide-react";
import { useTheme } from "./ThemeManager"; // Import the theme context
import "./css/DownloadableFile.css"; // Import the new CSS file
import ClickableImage from "./components/ClickableImage";


const DownloadableFile = ({ 
  filePath, 
  fileName, 
  title,
  fileType = "pdf", 
  showPreview = true,
  previewUrl,
  buttonText = "Download",
  description
}) => {
  const { currentTheme } = useTheme(); // Access the current theme
  
  // Determine file icon based on type
  const getFileIcon = () => {
    switch(fileType.toLowerCase()) {
      case 'pdf':
        return <FileText className="w-10 h-10 file-icon-pdf" />;
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
        return <FileType className="w-10 h-10 file-icon-image" />;
      default:
        return <File className="w-10 h-10 file-icon-default" />;
    }
  };

  // Generate display name for the file
// Generate display name for the file (never show full paths/URLs)
const basename = (v) => {
  const s = (v || "").toString().trim();
  if (!s) return "";
  const noHash = s.split("#")[0];
  const noQuery = noHash.split("?")[0];
  return noQuery.split("/").pop();
};

const displayName = title || basename(fileName) || basename(filePath) || "Download File";
const downloadName = basename(fileName) || basename(filePath) || "download";


  return (
    <div className="downloadable-file-container">
     {/* Preview section */}
     {showPreview && (
        <div className="downloadable-file-preview">
          {/* Key change: Check previewUrl first, regardless of fileType */}
          {previewUrl ? (
            <ClickableImage
              src={previewUrl}
              alt={`Preview of ${displayName}`}
              className="downloadable-file-preview-image"
              onError={(e) => {
                console.error(`Failed to load preview: ${previewUrl}`)
                e.target.style.display = "none"
                e.target.parentNode.innerHTML = `<div class="downloadable-file-preview-fallback">${getFileIcon()}</div>`
              }}
            />
          ) : (
            <div className="downloadable-file-preview-fallback">
              {getFileIcon()}
            </div>
          )}
        </div>
      )}
      
      {/* File info and download button */}
      <div className="downloadable-file-content">
        <h3 className="downloadable-file-title">{displayName}</h3>
        
        {description && (
          <p className="downloadable-file-description">{description}</p>
        )}
        
<a href={filePath} download={downloadName} className="downloadable-file-button">


          <Download className="downloadable-file-button-icon" />
          {buttonText}
        </a>
      </div>
    </div>
  );
};

export default DownloadableFile;